import { render, staticRenderFns } from "./ComHeader.vue?vue&type=template&id=e9929620&scoped=true"
import script from "./ComHeader.vue?vue&type=script&lang=js"
export * from "./ComHeader.vue?vue&type=script&lang=js"
import style0 from "./ComHeader.vue?vue&type=style&index=0&id=e9929620&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9929620",
  null
  
)

export default component.exports